import fetchWithDefaults from './fetchWithDefaults';
import { MESSAGES } from '../CommonConstants';
import { ApiError } from '../errors/ApiError';

export const authFetch = async (
  input: RequestInfo,
  init?: RequestInit & { extendSession?: boolean; showSpinner?: boolean },
) => {
  try {
    // Until we migrate fetchWithDefaults, we will use it.
    const response = await fetchWithDefaults(input, init);

    if (response.ok) {
      const { success, errors, payload } = await response.json();

      if (!success) {
        throw new ApiError(errors[0]);
      }

      return payload.viewData;
    }

    throw new Error();
  } catch (err) {
    // User aborted a request
    if (err instanceof DOMException) {
      throw err;
    }

    if (err instanceof ApiError) {
      throw err;
    }

    throw new Error(MESSAGES.GENERIC_ERROR);
  }
};
